/* ================================================================
   J.REDD THEME · v4.2 — PRODUCT PAGE CONTROLLER
   Powers ONLY the product landing page's new pieces: license-card selection,
   the mobile sticky purchase bar, and add-to-cart. It does NOT re-implement the
   player or cart — it reuses the shared engine via window.JREDD (exposed by
   theme.js). Fully null-guarded and a no-op on non-product pages.
================================================================ */
(function () {
  'use strict';
  if (!document.body || !document.body.classList.contains('template-product')) return;

  var LABELS = { lease: 'Lease', premium: 'Premium Lease', exclusive: 'Exclusive' };
  var selectedKey = 'premium';

  function jreddReady(cb) {
    if (window.JREDD && typeof window.JREDD.addToCart === 'function') cb();
    else document.addEventListener('jredd:ready', cb, { once: true });
  }

  function priceForKey(key) {
    var el = document.querySelector('.license-card[data-license="' + key + '"] .license-card__price');
    return el ? el.textContent.trim() : '';
  }

  function syncSticky() {
    var lic = document.getElementById('stickyCartLicense');
    var price = document.getElementById('stickyCartPrice');
    var addBtn = document.getElementById('stickyCartAdd');
    if (lic) lic.textContent = LABELS[selectedKey] || 'License';
    var p = priceForKey(selectedKey);
    if (price && p) price.textContent = p;
    if (addBtn) addBtn.setAttribute('data-add-license', selectedKey);
  }

  function selectLicense(key) {
    if (!key) return;
    selectedKey = key;
    var cards = document.querySelectorAll('.license-card');
    for (var i = 0; i < cards.length; i++) {
      cards[i].classList.toggle('is-selected', cards[i].getAttribute('data-license') === key);
    }
    syncSticky();
    // Keep the shared player's active tier in sync (price labels, sticky bar).
    if (window.JREDD && typeof window.JREDD.setLicense === 'function') window.JREDD.setLicense(key);
  }

  function addLicense(key) {
    jreddReady(function () {
      if (window.JREDD && typeof window.JREDD.addToCart === 'function') {
        window.JREDD.addToCart(0, key);
        if (typeof window.JREDD.openCart === 'function') window.JREDD.openCart();
      }
    });
  }

  // --- License card CTAs (Add <tier> to Cart) -----------------------------
  var ctas = document.querySelectorAll('button[data-add-license]');
  for (var i = 0; i < ctas.length; i++) {
    ctas[i].addEventListener('click', function (e) {
      var key = e.currentTarget.getAttribute('data-add-license');
      selectLicense(key);
      addLicense(key);
    });
  }

  // --- Selecting a card body highlights it + updates the sticky bar --------
  var cards = document.querySelectorAll('.license-card');
  for (var j = 0; j < cards.length; j++) {
    cards[j].addEventListener('click', function (e) {
      if (e.target.closest('button, a')) return; // let CTAs handle their own clicks
      selectLicense(e.currentTarget.getAttribute('data-license'));
    });
  }

  // --- Mobile sticky purchase bar -----------------------------------------
  var sticky = document.getElementById('stickyCart');
  var hero = document.getElementById('shopify-section-hero') || document.getElementById('storeCard');
  if (sticky && hero && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      for (var k = 0; k < entries.length; k++) {
        var en = entries[k];
        sticky.classList.toggle('visible', !en.isIntersecting || en.intersectionRatio < 0.2);
      }
    }, { threshold: [0, 0.2, 1] });
    io.observe(hero);
  }

  // --- v4.4: product-page bottom nav dock --------------------------------
  // Mirror the top nav (Beat Player / Licensing / Keep Digging / Browse All
  // Beats) in the fixed bottom dock — product pages only. theme.js renders the
  // dock during boot, so we re-apply whenever its contents are replaced (guarded
  // by a sentinel attribute to avoid a render loop). Smooth-scroll + active state
  // are handled by the existing global nav handler (theme-v4.js).
  (function () {
    var dock = document.getElementById('navDock');
    if (!dock) return;
    var ICONS = {
      player:  '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>',
      license: '<svg viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/></svg>',
      dig:     '<svg viewBox="0 0 24 24"><path d="M12 3 2 8l10 5 10-5-10-5zm0 7.05L4.26 6.1 12 5.16l7.74.94L12 10.05zM2 16l10 5 10-5-2.2-1.08L12 18.6 4.2 14.92 2 16z"/></svg>',
      browse:  '<svg viewBox="0 0 24 24"><path d="M4 11h6V5H4v6zm0 8h6v-6H4v6zm8 0h6v-6h-6v6zm0-14v6h6V5h-6z"/></svg>'
    };
    var ITEMS = [
      { label: 'BEAT PLAYER',  sub: 'Listen',    href: '#shopify-section-hero',      icon: ICONS.player },
      { label: 'LICENSING',    sub: 'Tiers',     href: '#shopify-section-licensing', icon: ICONS.license },
      { label: 'KEEP DIGGING', sub: 'More Beats',href: '#shopify-section-related',   icon: ICONS.dig },
      { label: 'BROWSE',       sub: 'All Beats', href: '/',                          icon: ICONS.browse }
    ];
    function buildDock() {
      dock.innerHTML = ITEMS.map(function (it, i) {
        return '<a class="nav-item' + (i === 0 ? ' active' : '') + '" href="' + it.href + '" data-jredd-dock aria-label="' + it.label + '">' +
          '<div class="nav-icon">' + it.icon + '</div>' +
          '<span class="nav-label">' + it.label + '</span>' +
          '<span class="nav-sub">' + it.sub + '</span></a>';
      }).join('');
    }
    function ensureDock() {
      if (!dock.querySelector('a[data-jredd-dock]')) buildDock();
    }
    ensureDock();
    if ('MutationObserver' in window) {
      new MutationObserver(ensureDock).observe(dock, { childList: true });
    }
  })();

  // --- Init ----------------------------------------------------------------
  syncSticky();
  selectLicense(selectedKey);
})();
